import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Box, Flex, Button } from '@elparking/components'
import FiltersBox from '../FiltersBox'
import {
    BottomBarWrapper,
} from '../../ui/BottomBar'
import { FormattedMessage } from 'react-intl'
const FilterBoxModal = ({
    isShown,
    onClose,
    setFilters: setDefaultFilters,
    filters: defaultFilters,
    onCleanFilters,
    isLoading,
}) => {
    const [filters, setFilters] = useState(defaultFilters)

    const onSave = () => {
        setDefaultFilters(filters)
        onClose()
    }

    return (
        <Modal padding='0' isShown={isShown} width='600px' onClose={onClose}>
            <Box padding='1em' paddingBottom='100px'>
                <FiltersBox isModal filters={filters} isLoading={isLoading} setFilters={setFilters} cleanFilters={onCleanFilters} />
            </Box>
            <BottomBarWrapper>
                <Flex padding='1em' width='100%' alignItems='center' justifyContent='space-between'>
                    <Box width='100%' m='0px 4px'>
                        <Button
                          hoverBackgroundColor='main'
                          backgroundColor='white'
                          hoverColor='white'
                          borderWidth='1px'
                          borderStyle='solid'
                          borderColor='main'
                          width='100%'
                          activeBackgroundColor='gray'
                          color='main'
                          textAlign='center'
                          onClick={onClose}>
                            <FormattedMessage defaultMessage='Cancelar' />
                        </Button>
                    </Box>
                    <Box m='0px 4px' width='100%'>
                        <Button onClick={onSave} width='100%'><FormattedMessage defaultMessage='Aplicar' /></Button>
                    </Box>
                </Flex>
            </BottomBarWrapper>
        </Modal>
    )
}

FilterBoxModal.propTypes = {
    isShown: PropTypes.bool,
    isLoading: PropTypes.bool,
    onClose: PropTypes.func,
    setFilters: PropTypes.func,
    filters: PropTypes.object,
    onCleanFilters: PropTypes.func,
}

export default FilterBoxModal
